const LoginIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_232_22164)">
        <path
          d="M1.8418 11.9988H17.1145M17.1145 11.9988L13.2963 8.72607M17.1145 11.9988L13.2963 15.2715"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.47949 6.54537C9.49258 4.17264 9.5984 2.88755 10.4362 2.04973C11.3951 1.09082 12.9377 1.09082 16.0228 1.09082H17.1137C20.1999 1.09082 21.7424 1.09082 22.7013 2.04973C23.6591 3.00755 23.6591 4.55118 23.6591 7.63628V16.3635C23.6591 19.4486 23.6591 20.9923 22.7013 21.9501C21.7413 22.909 20.1999 22.909 17.1137 22.909H16.0228C12.9377 22.909 11.3951 22.909 10.4362 21.9501C9.5984 21.1123 9.49258 19.8272 9.47949 17.4545"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_232_22164">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LoginIcon;
